import { Language } from '@ha/intl';
import { LocaleToCanonicalCollections } from 'ha/constants/SearchPageCollections';
import { Listing } from '@ha/api/v2/types/Listing';
import { getCategory } from './getCategory';

export function getCanonicalCategory(
  { kind, type }: Pick<Listing, 'kind' | 'type'>,
  lang: Language,
): string {
  const category = getCategory(kind, type);

  return (
    LocaleToCanonicalCollections[lang] &&
    LocaleToCanonicalCollections[lang][category]
  );
}
